import Vue from 'vue';
export default Vue.component('ed-loading', {
  name: 'ed-loading',
  props: {
    isLoading: Boolean,
  },

  data: () => {
    return {
      label: '',
      isShown: false
    }
  },
  methods: {
    show(label) {
      this.label = label ? label : this.$i18n.t('common.loading');
      this.isShown = true;
    },
    hide() {
      this.isShown = false;
    }
  },
  created() {
    this.label = this.$i18n.t('common.loading');
  }
});
